import React, { useEffect, useState, useCallback } from 'react';
import { Button, notification } from 'antd';
import ExportExcel from '../../ExportExcel';
import { groupData } from '../../utils/groupData';
import { getNetwork } from '../../../../../../utils/getNetwork';
import { API_ROOT } from '../../../../../../config';
import { combineSum } from '../../../../../GosService/utils';
import { saveBlob } from '../../../../../../utils/saveBlob';
import styles from './ExcelButton.module.scss';

// Отчет по мероприятиям: шаблона на фронте нет, файл собирает бек.
// Параметры те же, что у /edu-report/filter
const ActivityExportButton = ({ formValues, fileName }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    const { chartType, district, locality, org, year, month } = formValues;
    const queryFields = [
      { name: 'reportKindIds', value: chartType },
      { name: 'regionIds', value: district && district.id },
      { name: 'localityIds', value: locality },
      { name: 'organizationIds', value: org },
      { name: 'yearIds', value: year },
      { name: 'monthIds', value: month },
    ];
    const queryParam = new URLSearchParams();
    queryFields.forEach((query) => {
      if (query.value) {
        queryParam.set(query.name, query.value);
      }
    });

    setLoading(true);
    try {
      const response = await getNetwork().get(
        `${API_ROOT}/edu-report/export?${queryParam}`,
        { responseType: 'blob' }
      );
      saveBlob(response.data, `${fileName}.xlsx`);
    } catch (err) {
      notification.error({ message: 'Ошибка при экспорте в Excel' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button onClick={handleExport} loading={loading}>
      Экспорт в Excel
    </Button>
  );
};

export const ExcelButton = ({ formData, formValues, reports, isConsolidatedReport }) => {
  const [separateReports, setSeparateReports] = useState([]);
  const getDataForExcelFormat = (arrData) => {
    if (formValues.chartType === 2) {
      return groupData(arrData);
    }

    return arrData;
  };

  const generateTitleFile = (part, title, organizationResult, monthResult, yearResult) => {
    return title.replace(
      part,
      `${part} ${organizationResult
        ? organizationResult.nameRu : ''} ${monthResult && yearResult ? 'за ' + monthResult.nameRu + ' ' + yearResult.year
        : ''}`
    ).replace(/[.,/#!$%^&*;:{}=\-_`~()]$/g, '');
  };

  const createTitleFile = (title) => {
    const organizationResult = formData.orgs.find((orgObj) => orgObj.id === formValues.org);
    const monthResult = formData.months.find((monthObj) => monthObj.id === formValues.month);
    const yearResult = formData.years.find((yearObj) => yearObj.id === formValues.year);


    if (title.includes('Отчет по государственным услугам')) {
      return generateTitleFile('Отчет по государственным услугам', title, organizationResult, monthResult, yearResult);
    }

    if (title.includes('Отчет о выполнении')) {
      return generateTitleFile('Отчет о выполнении', title, organizationResult, monthResult, yearResult);
    }

    return title;
  };

  const withSummary = useCallback(
    data => {
        return combineSum(data, formValues.chartType).map(i => ({
        ...i,
        summaryFiz:
          i.electronicalyThroughtInformationSystemsFiz +
          i.inPeperFormFiz +
          i.serviceCountByStateorgCompaniesFiz +
          i.serviceCountByStateorgPeopleFiz +
          i.throughTheServiceProviderFiz,
        summaryYr:
          i.electronicalyThroughtInformationSystemsYr +
          i.inPeperFormYr +
          i.serviceCountByStateorgCompaniesYr +
          i.serviceCountByStateorgPeopleYr +
          i.throughTheServiceProviderYr,
      }));
    },
    [formValues.chartType]
  );

  const getChartData = useCallback(() => {
    const queryFields = [
      { name: 'yearId', value: formValues.year },
      { name: 'monthId', value: formValues.month },
      { name: 'quarter', value: formValues.quarter },
    ];
    const queryParam = new URLSearchParams();

    queryFields.forEach(query => {
      if (query.value) {
        queryParam.set(query.name, query.value);
      }
    });

    getNetwork()
      .get(
        API_ROOT +
          `/myReport//filter-by-org?reportType=REPORT_${formValues.chartType}&${queryParam}`
      )
      .then((res = {}) => {
        if (res.status === 200) {
          const result = res.data;
          const dataWithSum = formValues.chartType === 3 ? result : result.map(d => withSummary(d.data));
          setSeparateReports(dataWithSum);
        }
      });
  }, [formValues]);

  useEffect(() => {
    if (isConsolidatedReport) {
      getChartData();
    }
  }, [isConsolidatedReport])

  const fileName = createTitleFile(
    formData.chartTypes.find(i => i.id === formValues.chartType).name
  );

  return (
    <div className={styles.container}>
      <h3 className={styles.subtitle}>
        {fileName}
      </h3>
      {formValues.chartType === 2 ? (
        <ActivityExportButton formValues={formValues} fileName={fileName} />
      ) : (
        <ExportExcel
          fileName={fileName}
          chartType={formValues.chartType}
          data={getDataForExcelFormat(reports)}
          separateData={separateReports}
          isConsolidatedReport={isConsolidatedReport}
        />
      )}
    </div>
  );
};
